// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.941Z

import {
    PostMediaFileApiResponse,
    PostMediaFileApiArg,
    PostMediaMediastreamvalidatorApiResponse,
    PostMediaMediastreamvalidatorApiArg
} from "~/api/mediaAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postMediaFile: build.mutation<
            PostMediaFileApiResponse,
            PostMediaFileApiArg
        >({
            query: (queryArg) => ({
                url: "/media/file",
                method: "POST",
                body: queryArg.mediaPostMediaFileRequest,
                headers: {"X-Recaptcha-Token": queryArg["X-Recaptcha-Token"]},
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postMediaMediastreamvalidator: build.mutation<
            PostMediaMediastreamvalidatorApiResponse,
            PostMediaMediastreamvalidatorApiArg
        >({
            query: (queryArg) => ({
                url: "/media/mediastreamvalidator",
                method: "POST",
                body: queryArg.mediaPostMediaStreamValidatorRequest,
                headers: {"X-Recaptcha-Token": queryArg["X-Recaptcha-Token"]},
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as mediaAPI };
export const {
    usePostMediaFileMutation,
    usePostMediaMediastreamvalidatorMutation,
} = injectedRtkApi;
